var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCameraIconOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    role: "img",
    "aria-labelledby": titleId,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Video interview scheduling") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Calendar with small date boxes and a video camera icon inside representing a scheduled video interview")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 52,
    height: 44,
    rx: 3,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 20,
    x2: 58,
    y2: 20,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 6,
    x2: 20,
    y2: 12,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 6,
    x2: 44,
    y2: 12,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 28,
    width: 6,
    height: 6,
    rx: 1,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 28,
    width: 6,
    height: 6,
    rx: 1,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 38,
    width: 6,
    height: 6,
    rx: 1,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34,
    width: 14,
    height: 10,
    rx: 2,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46,36 54,32 54,44 46,40",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCameraIconOutline);
export default __webpack_public_path__ + "static/media/calendar_camera_icon_outline.58f0070b12c7cd92ee7253e9142b68a1.svg";
export { ForwardRef as ReactComponent };